import { useEffect, useState } from 'react';
import { pdfjs } from 'react-pdf';
import { colors } from '../styles';

interface InlinePdfViewerProps {
  url: string;
  maxHeight?: number | string;
  hint?: string;
}

const InlinePdfViewer = ({ url, maxHeight = '60vh', hint }: InlinePdfViewerProps) => {
  const [loading, setLoading] = useState(true);
  const [errored, setErrored] = useState(false);

  useEffect(() => {
    pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
  }, []);

  const fillParent = maxHeight === '100%';
  const iframeHeight = fillParent ? '100%' : typeof maxHeight === 'number' ? `${maxHeight}px` : maxHeight;

  return (
    <div
      style={
        fillParent ? { display: 'flex', flexDirection: 'column', height: '100%', minHeight: 0 } : { marginBottom: 20 }
      }
    >
      {hint && (
        <div style={{ fontSize: 12, color: colors.muted, marginBottom: 8 }}>
          <i className="fas fa-info-circle" style={{ marginRight: 6 }} />
          {hint}
        </div>
      )}
      <div
        style={{
          position: 'relative',
          border: `1px solid ${colors.border}`,
          borderRadius: 10,
          overflow: 'hidden',
          background: '#F9FAFB',
          ...(fillParent ? { flex: 1, minHeight: 0 } : {}),
        }}
      >
        {loading && !errored && (
          <div
            style={{
              position: 'absolute',
              inset: 0,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              background: 'rgba(255,255,255,0.7)',
              zIndex: 1,
              fontSize: 13,
              color: colors.muted,
            }}
          >
            <i className="fas fa-spinner fa-spin" style={{ marginRight: 8 }} />
            Loading document...
          </div>
        )}
        <iframe
          title="document"
          src={`${url}#toolbar=0&navpanes=0&scrollbar=1&view=FitH`}
          style={{
            width: '100%',
            height: iframeHeight,
            border: 'none',
            display: 'block',
          }}
          onLoad={() => setLoading(false)}
          onError={() => {
            setErrored(true);
            setLoading(false);
          }}
        />
      </div>
      {errored && (
        <div style={{ fontSize: 12, color: colors.danger, marginTop: 6 }}>
          Could not preview the document inline.{' '}
          <a href={url} target="_blank" rel="noopener noreferrer" style={{ color: colors.accent }}>
            Open in a new tab
          </a>
          .
        </div>
      )}
    </div>
  );
};

export default InlinePdfViewer;
